import { REQUEST_TEACHER_ASSIGN_START } from 'pages/testroom/constants/commands';
import { Socket } from 'socket.io-client';

export const requestAssignStart = (props: { socket: Socket | null }) => {
    if (props.socket == null) {
        return;
    }

    const token = localStorage.getItem('token') ?? '';
    props.socket?.emit(REQUEST_TEACHER_ASSIGN_START, { token: token });
};
